module.exports = __webpack_public_path__ + "img/crema, pomada, gel, pasta o ungüento dermico.c3ed2c3c.png";